import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function currencies(state = initialState.currencies, action) {
  switch (action.type) {
    case types.SET_CURRENCIES:
      return action.currencies;
    default:
      return state;
  }
}
